import { BoxLeadDetailsHeader } from "@modules/boxLead/components/boxLeadInfo/boxLeadDetailsHeader"
import { BoxLeadOffersLayout } from "@modules/boxLead/components/boxLeadInfo/boxLeadOffersLayout"
import { BoxLeadOverview } from "@modules/boxLead/components/boxLeadInfo/boxLeadOverview"
import { BoxLeadOverviewSkeleton } from "@modules/boxLead/components/boxLeadInfo/boxLeadOverviewSkeleton"
import { BoxLeadPublicProfil } from "@modules/boxLead/components/boxLeadInfo/boxLeadPublicProfil"
import { BoxLeadTab } from "@modules/boxLead/components/boxLeadInfo/boxLeadTab"
import { BoxLeadTabSkeleton } from "@modules/boxLead/components/boxLeadInfo/boxLeadTabSkeleton"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { HuAvatarCardSidebarSkeleton } from "@modules/ui/components/huAvatarCardSidebarSkeleton"
import { Suspense } from "react"

type BoxLeadDetailsInfoLayoutProps = {
  leadId: string
  className?: string
} & React.ComponentProps<"div">

export function BoxLeadDetailsInfoLayout({ leadId, className, ...props }: BoxLeadDetailsInfoLayoutProps) {
  const defaultClassName = "flex flex-column w-full"

  const { getCurrentStackState } = useSidebar()
  const activeIndex = getCurrentStackState("activeTabIndex") ?? 0

  return (
    <div className={className ?? defaultClassName} {...props}>
      {/* HEADER */}
      <Suspense fallback={<HuAvatarCardSidebarSkeleton />}>
        <BoxLeadDetailsHeader leadId={leadId} />
      </Suspense>

      {/* NAVIGATION TABS */}
      <Suspense fallback={<BoxLeadTabSkeleton activeIndex={activeIndex} />}>
        <BoxLeadTab activeIndex={activeIndex} leadId={leadId} />
      </Suspense>
      {/* OVERVIEW */}
      {activeIndex === 0 && (
        <Suspense fallback={<BoxLeadOverviewSkeleton />}>
          <BoxLeadOverview leadId={leadId} />
        </Suspense>
      )}
      {/* PUBLIC PROFIL */}
      {activeIndex === 1 && <BoxLeadPublicProfil leadId={leadId} />}
      {/* OFFERS */}
      {activeIndex === 2 && <BoxLeadOffersLayout leadId={leadId} />}
    </div>
  )
}
